import React from 'react';
import { PortfolioEntry } from '../../squads/classroom/types';
import { cardsForEntry, universeCardUrl } from './cardReadiness';
import { useSquadUniverseCards } from './SquadUniverseCards';
import { UniverseCardFace } from './UniverseCardFace';

export function PortfolioUniverseCards({ entry }: { entry: PortfolioEntry }) {
  const { cards } = useSquadUniverseCards();
  const published = cardsForEntry(cards, entry).filter(card => card.status === 'published');
  if (!published.length) return null;
  return <section aria-label="Published Universe cards"><h4>Published Universe cards</h4><div className="portfolio-universe-cards">{published.map(card => <div className="portfolio-universe-card" key={card.id}>
    <div inert><UniverseCardFace card={card} /></div>
    <a href={universeCardUrl(card.id)} target="_blank" rel="noreferrer" aria-label={`Open ${card.title} in Overture Universe`} />
  </div>)}</div></section>;
}
